/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 18.02.15.
 */

angular.module('farmnet.partner.externalAccounts').factory('ExternalAccount', [
  'app',
  'ExternalCredentials',
  'ShopService',
  function ExternalAccountFactory(app, ExternalCredentials, ShopService) {
    'use strict';

    function ExternalAccount(account) {
      //// Preconditions
      if (angular.isUndefined(account) || !angular.isObject(account)) {
        throw Error('Argument error: credentials must be an object');
      }

      //// Transform object from server
      // extend properties to this
      angular.extend(this, account);

      if (this.credentials !== null) {
        this.credentials = new ExternalCredentials(this.credentials);
      }
    }

    //// Public methods
    ExternalAccount.prototype.requiredServiceExists = function() {
      if (this.requiredService === null) {
        return true;
      } else {
        return ShopService.isProductLicensed(this.requiredService);
      }
    };

    //// Public properties, see corresponding JavaDoc
    ExternalAccount.prototype.id = null;

    ExternalAccount.prototype.key = null;

    ExternalAccount.prototype.vendor = null;

    ExternalAccount.prototype.name = null;

    ExternalAccount.prototype.credentialsTestable = false;

    ExternalAccount.prototype.requiredService = null;

    ExternalAccount.prototype.group = null;

    /**
     *
     * @type {number}
     */
    ExternalAccount.prototype.order = 0;

    ExternalAccount.prototype.credentials = null;

    //// our factory creates a class constructor
    return ExternalAccount;
  }
]);
